export const SET_SCHEDULED_REPORT = 'SET_SCHEDULED_REPORT'
export const RESET_SCHEDULED_REPORT= 'RESET_SCHEDULED_REPORT'
